// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"f6085512","455":"c2439c9d","977":"1589f79d"}[chunkId] + ".chunk.js";
};